import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { SearchHistoryItem } from '@search/const';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { SearchActions } from './actions';
import { SEARCH_FEATURE, StateWithSearch } from './search-state';
import { SearchSelectors } from './selectors';

@Injectable({
  providedIn: 'root',
})
export class SearchStatePersistenceService {
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected store: Store<StateWithSearch>,
  ) {}

  public sync(): void {
    this.statePersistenceService.syncWithStorage({
      key: SEARCH_FEATURE,
      state$: this.getState(),
      storageType: StorageSyncType.LOCAL_STORAGE,
      onRead: (state) => this.onRead(state),
    });
  }

  protected getState(): Observable<SearchHistoryItem[]> {
    return this.store.pipe(select(SearchSelectors.getSearchHistoryState));
  }

  protected onRead(state: SearchHistoryItem[]): void {
    if (state) {
      this.store.dispatch(new SearchActions.SearchHistorySetState(state));
    }
  }
}
